import { default as moment } from "moment";
import * as React from "react";
import {
  Channel,
  Housing,
  NegotiatePeriod,
  Offer,
  PriceClient,
  Savings,
  SpotPrice,
} from "../api/ApiClient";

interface Props {
  savings: Savings;
  offer: Offer;
  consumption: number;
}

interface State {
  spotprice?: SpotPrice;
}

export default class SavingsDescriptionModal extends React.PureComponent<
  Props,
  State
> {
  state = { spotprice: null };
  private priceClient: PriceClient = new PriceClient();

  async componentDidMount() {
    try {
      let spotprices = await this.priceClient.list(
        0,
        this.props.offer.salesChannel
      );

      this.setState({
        spotprice:
          spotprices?.length > 0
            ? spotprices.sort((p1, p2) =>
                p1.fromDate > p2.fromDate ? 1 : 0
              )[0]
            : null,
      });
    } catch (error) {
      console.debug("Failed to get spot prices", error);
    }
  }

  render() {
    return (
      <div
        className="modal fade"
        id="prisModal"
        role="dialog"
        aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <p className="subheading">Besparing med Ren Enklel Billig El</p>
              <p className="copy">
                Din beräknade besparing är baserad på en uppskattad
                årsförbrukning utifrån de uppgifter du angav
                {this.props.offer.salesChannel == Channel.SODERBERG_PARTNERS
                  ? " under rådgivningen"
                  : ""}
                . Vidare så har vi jämfört vårt elpris med ett snittpris bland
                de största elhandelsbolagen på marknaden.
              </p>
              <p className="subheading">Dina uppgifter</p>
              <div className="table-responsive">
                <table className="table">
                  <tbody>
                    <tr>
                      <td>Typ av boende</td>
                      <td>
                        {this.props.offer.housing == Housing.LAGENHET
                          ? "Lägenhet"
                          : null}
                        {this.props.offer.housing == Housing.VILLA
                          ? "Villa"
                          : null}
                        {this.props.offer.housing == Housing.RADHUS
                          ? "Radhus"
                          : null}
                        {this.props.offer.housing == Housing.FRITIDSHUS
                          ? "Fritidshus"
                          : null}
                      </td>
                    </tr>
                    <tr>
                      <td>Storlek på boende</td>
                      <td>{this.props.offer.area} kvm</td>
                    </tr>
                    <tr>
                      <td>Uppskattad förbrukning</td>
                      <td>{this.props.consumption} kWh</td>
                    </tr>
                    <tr>
                      <td>Senast tecknat elavtal</td>
                      <td>
                        {this.props.offer.negotiatePeriod ==
                        NegotiatePeriod.ONE_YEAR
                          ? "1 år sedan"
                          : null}
                        {this.props.offer.negotiatePeriod ==
                        NegotiatePeriod.THREE_YEARS
                          ? "1-3 år sedan"
                          : null}
                        {this.props.offer.negotiatePeriod ==
                        NegotiatePeriod.FIVE_YEARS
                          ? "3-5 år sedan"
                          : null}
                        {this.props.offer.negotiatePeriod ==
                        NegotiatePeriod.NEVER
                          ? "Aldrig"
                          : null}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p className="copy">
                Med Ren Enkel Billig El får du ett rörligt elavtal med en fast
                avgift enligt nedan.
              </p>
              {this.state.spotprice ? (
                <>
                  <p className="subheading">
                    Vårt rörliga pris i{" "}
                    {moment(this.state.spotprice.fromDate)
                      .format("MMMM")
                      .toLowerCase()}
                  </p>
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <td>Elområde</td>
                          <td>Rörliga pris (öre/kWh)</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>SE1</td>
                          <td>
                            {(this.state.spotprice.priceSE1 * 100)?.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>SE2</td>
                          <td>
                            {(this.state.spotprice.priceSE2 * 100)?.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>SE3</td>
                          <td>
                            {(this.state.spotprice.priceSE3 * 100)?.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>SE4</td>
                          <td>
                            {(this.state.spotprice.priceSE4 * 100)?.toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </>
              ) : null}
              <p className="subheading">Vår fasta månadsavgift</p>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <td>Förbrukning (kWh/år)</td>
                      <td>Månadsavgift (kr/mån)</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      className={
                        this.props.consumption <= 5000 ? "font-weight-bold" : ""
                      }>
                      <td>0 - 5 000</td>
                      <td>38</td>
                    </tr>
                    <tr
                      className={
                        this.props.consumption > 5000 &&
                        this.props.consumption <= 10000
                          ? "font-weight-bold"
                          : ""
                      }>
                      <td>5 001 - 10 000</td>
                      <td>48</td>
                    </tr>
                    <tr
                      className={
                        this.props.consumption > 10000 &&
                        this.props.consumption <= 15000
                          ? "font-weight-bold"
                          : ""
                      }>
                      <td>10 001 - 15 000</td>
                      <td>68</td>
                    </tr>
                    <tr
                      className={
                        this.props.consumption > 15000 &&
                        this.props.consumption <= 20000
                          ? "font-weight-bold"
                          : ""
                      }>
                      <td>15 001 - 20 000</td>
                      <td>78</td>
                    </tr>
                    <tr
                      className={
                        this.props.consumption > 20000 &&
                        this.props.consumption <= 25000
                          ? "font-weight-bold"
                          : ""
                      }>
                      <td>20 001 - 25 000</td>
                      <td>88</td>
                    </tr>
                    <tr
                      className={
                        this.props.consumption > 25000 &&
                        this.props.consumption <= 50000
                          ? "font-weight-bold"
                          : ""
                      }>
                      <td>25 001 - 50 000</td>
                      <td>98</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p className="copy">
                Om du vill se mer i detalj hur besparingen skulle se ut för just
                dig så kan du maila in din senaste faktura till oss på{" "}
                <a href="mailto:info@renenkelbilligel.se">
                  info@renenkelbilligel.se
                </a>{" "}
                så återkommer vi med en exakt jämförelse.
              </p>
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal">
                Stäng
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
